export enum SignupActionType {
  SET_STATE_DATA,
  START_SIGNUP_SESSION = 'START_SIGNUP_SESSION',
  UPDATE_SIGNUP_SESSION = 'UPDATE_SIGNUP_SESSION'
}
